import type { FunctionComponent } from "react";
import type { GetProps } from "tamagui";
import type { IconProps } from "@tamagui/helpers-icon";
import { Paragraph, type ParagraphProps, Separator, styled, XStack, YStack, type YStackProps } from "@medbillai/ui";
import { BackgroundRadialGrantedGradient } from "../../../components/BackgroundRadialGrantedGradient";
export const Divider = styled(Separator, {
  borderBottomColor: "$surface0",
  borderBottomWidth: 6,
  width: "100%"
});
const Gradient = (props: GetProps<typeof BackgroundRadialGrantedGradient>) => <BackgroundRadialGrantedGradient fullscreen={false} objectFit="fill" {...props} data-sentry-element="BackgroundRadialGrantedGradient" data-sentry-component="Gradient" data-sentry-source-file="WidgetWrapper.tsx" />;
export function WidgetWrapper({
  title,
  titleIcon: TitleIcon,
  showGradient,
  children,
  wrapperProps,
  titleProps,
  removeDivider = false
}: {
  title: string;
  titleIcon?: FunctionComponent<IconProps>;
  showGradient?: "full" | "inner";
  children: React.ReactNode;
  wrapperProps?: YStackProps;
  titleProps?: ParagraphProps;
  removeDivider?: boolean;
}) {
  return <>
      <YStack py="$sp4" px="$sp2.5" {...wrapperProps} data-sentry-element="YStack" data-sentry-source-file="WidgetWrapper.tsx">
        {showGradient === "full" ? <Gradient /> : null}
        {TitleIcon ? <XStack alignItems="center" gap="$1" pb="$4">
            <TitleIcon size="$1" color="$textDefault" />
            <Paragraph {...titleProps}>{title}</Paragraph>
          </XStack> : <Paragraph pb="$4" {...titleProps}>
            {title}
          </Paragraph>}
        {showGradient === "inner" ? <YStack padding="$7">
            <Gradient borderRadius="$4" />
            {children}
          </YStack> : children}
      </YStack>
      {removeDivider ? null : <Divider />}
    </>;
}